import { MicNone } from "@mui/icons-material";
import React, { memo } from "react";
import { NodeCard, mutedText } from "./commonNode";

const accent = "#ef5350";

export default memo(({ data, isConnectable, id }) => {
  const link =
    process.env.REACT_APP_BACKEND_URL === "http://localhost:8090"
      ? "http://localhost:8090"
      : process.env.REACT_APP_BACKEND_URL;

  return (
    <NodeCard
      id={id}
      title="Audio"
      accent={accent}
      icon={<MicNone sx={{ width: 15, height: 15, color: accent }} />}
      isConnectable={isConnectable}
      width={260}
      targetTop="50%"
      sourceHandles={[{ id: "a", top: "78%" }]}
    >
      <div style={{ ...mutedText, marginBottom: 8 }}>
        {data.record ? "Gravado na hora" : "Audio enviado"}
      </div>
      <audio controls style={{ width: "100%" }}>
        <source src={`${link}/public/${data.url}`} type="audio/mp3" />
        seu navegador não suporta HTML5
      </audio>
    </NodeCard>
  );
});
